// @flow

import styled from "@emotion/styled";

import { Button } from "../styles";

export const Process = styled(Button)``;
